import { useState } from "react";
import { Dayjs } from "dayjs";
import { Flex, Form, Space, Typography } from "antd";
import { useTranslate } from "@refinedev/core";
import { Button, DatePicker } from "@libertify/ui";
import { useDataExports } from "../../hooks/useDataExports";
import type { BundleResponse } from "@/types";

type TriggerCardProps = {
  onAlreadyInProgress: (bundle?: BundleResponse) => void;
};

export const TriggerCard = ({ onAlreadyInProgress }: TriggerCardProps) => {
  const t = useTranslate();
  const { triggerExport, isCreating } = useDataExports();
  const [dateFrom, setDateFrom] = useState<Dayjs | null>(null);
  const [dateTo, setDateTo] = useState<Dayjs | null>(null);

  const handleSubmit = async () => {
    const result = await triggerExport({
      date_from: dateFrom ? dateFrom.format("YYYY-MM-DD") : null,
      date_to: dateTo ? dateTo.format("YYYY-MM-DD") : null,
    });
    if (result.alreadyInProgress) {
      onAlreadyInProgress(result.bundle);
    }
  };

  return (
    <Form
      layout="vertical"
      onFinish={() => {
        handleSubmit().catch((error) => {
          console.error("Error triggering data export", error);
        });
      }}
    >
      <Typography.Title level={4} style={{ marginTop: 0 }}>
        {t("media.organizations.dataExport.heading")}
      </Typography.Title>
      <Typography.Paragraph type="secondary">
        {t("media.organizations.dataExport.subheading")}
      </Typography.Paragraph>
      <Flex gap="large" align="end">
        <Form.Item
          label={t("media.organizations.dataExport.dateFromLabel")}
          style={{ marginBottom: 0 }}
        >
          <DatePicker value={dateFrom} onChange={(date) => setDateFrom(date)} />
        </Form.Item>
        <Form.Item
          label={t("media.organizations.dataExport.dateToLabel")}
          style={{ marginBottom: 0 }}
        >
          <DatePicker value={dateTo} onChange={(date) => setDateTo(date)} />
        </Form.Item>
        <Button variant="primary" htmlType="submit" loading={isCreating}>
          {t("media.organizations.dataExport.exportCta")}
        </Button>
      </Flex>
    </Form>
  );
};

export default TriggerCard;
